// extracted by mini-css-extract-plugin
module.exports = {"Link":"Link_Link__lzynb","Link___sm":"Link_Link___sm__lB_vD","Link_arrowIcon":"Link_Link_arrowIcon__bFRbV"};